import axios from "axios";
import $ from "jquery"

export default {
	newResource(formData, progressFunc) {
		console.log("progressFunc : ",progressFunc)
		return axios.post("/v3/resource", formData, {
			headers: { "Content-Type": undefined },
			onUploadProgress: progressFunc
		});
	},
	newTempResource(formData, progressFunc) {
		console.log("progressFunc : ",progressFunc)
		return axios.post("/v3/temp_resource", formData, {
			headers: { "Content-Type": undefined },
			onUploadProgress: progressFunc
		});
	},
	removeResource(item_id, resource_id) {
		return axios.delete(`/v3/resource/${item_id}/${resource_id}`);
	},

	viewResourcePDF(item_id, resource) {

		var windowRef = window.open();
		var request =  axios.get(`/v3/public_resource_url/${item_id}/${resource.id}`);

		request.then(resp => {
			// window.open(resp.data);
			windowRef.location = resp.data;
		});

	},

	viewResource(item_id, resource) {
		var windowRef = window.open();
		var request = axios.get(`/v3/resource_url/${item_id}/${resource.id}`);
		// request.then(resp => {
		// 	// window.open(resp.data);
		// 	windowRef.location = resp.data;
		// });
		request.then(resp => {
			let origFileName = resource.path
			let parts = origFileName.split(".")
			let ext = parts[parts.length - 1]
			let niceFileName = `${resource.name}.${ext}`

			$.ajax({
				url: resp.data,
				xhrFields: {
					responseType: 'blob'
				},
				success: data => {
					var url = window.URL || window.webkitURL;
					var path = url.createObjectURL(data);
					const link = document.createElement('a');
					link.href = path;
					link.setAttribute('download', niceFileName);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				},
				error: e => {
					console.error(e)
				}
			});
		})
	},

	viewPublicResource(item_id, resource) {
		var windowRef = window.open();
		var request = axios.get(`/v3/public_resource_url/${item_id}/${resource.id}`);
		// request.then(resp => {
		// 	// window.open(resp.data);
		// 	windowRef.location = resp.data;
		// });
		request.then(resp => {
			let origFileName = resource.path
			let parts = origFileName.split(".")
			let ext = parts[parts.length - 1]
			let niceFileName = `${resource.name}.${ext}`

			$.ajax({
				url: resp.data,
				xhrFields: {
					responseType: 'blob'
				},
				success: data => {
					var url = window.URL || window.webkitURL;
					var path = url.createObjectURL(data);
					const link = document.createElement('a');
					link.href = path;
					link.setAttribute('download', niceFileName);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				},
				error: e => {
					console.error(e)
				}
			});
		})
	},
	viewTempResource(item_id, resource_id) {
		var windowRef = window.open();
		var request = axios.get(`/v3/temp_resource_url/${item_id}/${resource_id}`);
		request.then(resp => {
			// window.open(resp.data);
			windowRef.location = resp.data;
		});
	},
	viewExternalResource(path) {
		var windowRef = window.open();
		windowRef.location = path;
	},
	HTMLResource(assessment_id,sequence){
		return axios.get(`/v3/htmlresource/${assessment_id}/${sequence}`)
	},
	HTMLPublicResource(assessment_id,sequence){
		return axios.get(`/v3/public_htmlresource/${assessment_id}/${sequence}`)
	},
	// Angular service
	// service.newResource = function(formData){
	// 	var header = serviceUtil.makeHeader().headers;
	// 	header['Content-Type'] = undefined;
	// 	return serviceUtil.makePromise($http.post("/v1/admin/resource", formData, {
	// 		headers: header,
	// 		transformRequest: angular.identity
	// 	}))
	// };

	// service.removeResource = function(item_id, resource_id){
	// 	var url = "/v1/admin/resource/"+item_id+"/"+resource_id;
	// 	return serviceUtil.makePromise($http.delete(url, serviceUtil.makeHeader()))
	// };

	// service.viewResource = function(item_id, resource_id){
	// 	var url = "/v1/admin/resource_url/"+item_id+"/"+resource_id;
	// 	var request = serviceUtil.makePromise($http.get(url, serviceUtil.makeHeader()))
	// 	request.then(function(d){
	// 		window.open(d)
	// 	})
	// }
};



// WEBPACK FOOTER //
// ./src/services/ResourceService.js